/**
 * Render-ready rows for dynamic Application Form custom questions (TT-65),
 * shared by the Rental Status and Employment "Additional Questions" cards.
 * Rows come pre-derived (custom-question-display.ts) — this is presentation
 * only, matching the YesNoWithExplanation field style.
 */
import type { CustomQuestionRow } from '#app/utils/application-detail-v2/custom-question-display'
import { questionLabel } from '#app/utils/application-detail-v2/display'
import { FieldBox } from '../primitives'

export function CustomQuestionAnswerList({
	rows,
}: {
	rows: CustomQuestionRow[]
}) {
	if (rows.length === 0) return null
	return (
		<>
			{rows.map((row) => (
				<div key={row.key} className="space-y-4">
					{/* Title-cased for display only — the derived row keeps the
					    landlord's prompt verbatim for the PDF / AI payload. */}
					<FieldBox label={questionLabel(row.prompt)} value={row.answer} />
					{row.explanation !== null ? (
						<FieldBox label="Explanation">
							<span className="block text-[15px] font-medium whitespace-pre-wrap wrap-break-word text-[#32302F]">
								{row.explanation}
							</span>
						</FieldBox>
					) : null}
				</div>
			))}
		</>
	)
}
